/* 🤖 this file was generated by svg-to-ts */
export const emperorIconLogout2: {
  name: 'logout_2';
  data: string;
} = {
  name: 'logout_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M22 11l-11.59 0 2.29-2.3 -1.42-1.42 -4.71 4.699 4.7 4.71 1.41-1.42 -2.29-2.3 11.582 0Z"/><path d="M19.411 15c-1.19 2.92-4.061 5-7.42 5 -4.42 0-8-3.59-8-8 0-4.42 3.58-8 8-8 3.35 0 6.221 2.07 7.41 5h2.12c-1.28-4.06-5.07-7-9.538-7 -5.52 0-10 4.487-10 10 0 5.51 4.48 10 10 10 4.46 0 8.261-2.95 9.53-7H19.38Z"/></g></svg>`
};
